<ng-template #accountApmCapReachedTooltip>
  Your account has reached a usage cap for performance events. This card may be
  missing performance data.
</ng-template>

<div class="ab-cards">
  <div class="ab-card ab-card--wide">
    <div
      class="ab-card__alert"
      *ngIf="accountApmCapReached"
      [ngbTooltip]="accountApmCapReachedTooltip"
    ></div>
    <ab-apdex-card
      [routesStats]="routesStats"
      [statusCode]="statusCode"
      [dur]="dur"
      [lastN]="lastN"
      [project]="project"
      [loading]="loading"
    ></ab-apdex-card>
  </div>
  <div class="ab-card ab-card--wide">
    <div
      class="ab-card__alert"
      *ngIf="accountApmCapReached"
      [ngbTooltip]="accountApmCapReachedTooltip"
    ></div>
    Requests
    <h1 class="ab-card__data" *ngIf="!loading">
      {{ requestCount | numberToHuman }}
      <ab-trend
        class="ab-card__trend"
        [countList]="requestCountList"
        [dur]="dur"
        [statType]="'requests'"
        [neutralStyle]="true"
      ></ab-trend>
    </h1>
    <ab-response-codes-bar
      class="response-codes-bar-container response-codes-bar-container--absolute"
      [data]="codesBar"
      *ngIf="!loading"
    ></ab-response-codes-bar>
    <div *ngIf="loading">
      <ab-spinner-inline></ab-spinner-inline>
    </div>
  </div>
  <div class="ab-card ab-card--wide">
    <div
      class="ab-card__alert"
      *ngIf="accountApmCapReached"
      [ngbTooltip]="accountApmCapReachedTooltip"
    ></div>
    Request rate
    <h1 class="ab-card__data" *ngIf="!loading">
      {{ requestCountPerMin | rateFormat }}<span class="text-unit">/min</span>
      <ab-trend
        class="ab-card__trend"
        [countList]="requestCountList"
        [dur]="dur"
        [statType]="'requests'"
        [neutralStyle]="true"
      ></ab-trend>
    </h1>
    <div *ngIf="loading">
      <ab-spinner-inline></ab-spinner-inline>
    </div>
  </div>
  <div class="ab-card ab-card--wide" *ngIf="!showPerformanceBreakdown">
    <div
      class="ab-card__alert"
      *ngIf="accountApmCapReached"
      [ngbTooltip]="accountApmCapReachedTooltip"
    ></div>
    Response time (mean)
    <h1 class="ab-card__data" *ngIf="!loading">
      <ab-duration-format [milliseconds]="requestMean"></ab-duration-format>
      <ab-trend
        class="ab-card__trend"
        [countList]="requestMeanList"
        [dur]="dur"
        [statType]="'response time'"
        [performanceTrend]="true"
      ></ab-trend>
    </h1>
    <div *ngIf="loading">
      <ab-spinner-inline></ab-spinner-inline>
    </div>
  </div>
  <div
    class="ab-card ab-card--wide"
    *ngIf="statusCode && statusCode.name === 'total'"
  >
    <div
      class="ab-card__alert"
      *ngIf="accountApmCapReached"
      [ngbTooltip]="accountApmCapReachedTooltip"
      placement="left"
    ></div>
    Error rate
    <div
      class="card-tooltip"
      ngbTooltip="Error occurrences per request"
      placement="left"
    >
      <span class="glyphicon glyphicon-question-circle glyphicon--blue"></span>
    </div>
    <h1 class="ab-card__data" *ngIf="!loading">
      {{ errorRate | rateFormat }}<span class="text-unit">%</span>
      <ab-trend
        class="ab-card__trend"
        [countList]="errorRateList"
        [dur]="dur"
        [statType]="'error rate'"
        [performanceTrend]="true"
      ></ab-trend>
    </h1>
    <div *ngIf="loading">
      <ab-spinner-inline></ab-spinner-inline>
    </div>
  </div>
</div>
